import * as React from "react";

const IconArrowLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 13">
            <path
                fill="currentColor"
                d="M5.25 3.5v-3H1.125C.504.5 0 1.004 0 1.625v9.75c0 .621.504 1.125 1.125 1.125h6.75C8.496 12.5 9 11.996 9 11.375V4.25H6.021a.754.754 0 0 1-.771-.75Zm-1.709 7.146a.328.328 0 0 1-.167.09l-1.302.262a.165.165 0 0 1-.194-.194l.26-1.301a.328.328 0 0 1 .09-.168l2.288-2.288L5.83 8.36l-2.29 2.286Zm3.007-4.704.385.385a.656.656 0 0 1 0 .928l-.574.574-1.312-1.313.573-.574a.658.658 0 0 1 .928 0ZM6 .5v3h3l-3-3Z"
            />
        </svg>
    );
};

export default React.memo(IconArrowLeft);
